import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import img1234 from './assets/IMG_1234.jpg';
import img3872 from './assets/IMG_3872.jpg';
import img4163 from './assets/IMG_4163.jpg';
import img4955 from './assets/IMG_4955.JPG';
import img6167 from './assets/IMG_6167.jpg';
import img6465 from './assets/IMG_6465.JPG';
import backgroundImage from './assets/background.jpg';

interface WeddingAdDialogProps {
  open: boolean;
  onClose: () => void;
}

const weddingImages = [
  {
    src: img4163,
    alt: 'Arnaud et Léo 1',
    rotation: '5deg',
    accent: '#f8c7c1',
  },
  {
    src: img3872,
    alt: 'Arnaud et Léo 2',
    rotation: '-7deg',
    accent: '#f6d9a6',
  },
  {
    src: img4955,
    alt: 'Arnaud et Léo 3',
    rotation: '-4deg',
    accent: '#d3e6c8',
  },
  {
    src: img1234,
    alt: 'Arnaud et Léo 5',
    rotation: '6deg',
    accent: '#cbdcf8',
  },
  {
    src: img6465,
    alt: 'Arnaud et Léo 6',
    rotation: '-5deg',
    accent: '#f4d3ee',
  },
  {
    src: img6167,
    alt: 'Arnaud et Léo 4',
    rotation: '-3deg',
    accent: '#f6e0b8',
  },
];

export const WeddingAdDialog: FunctionComponent<WeddingAdDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="wedding-ad-dialog-title"
      aria-describedby="wedding-ad-dialog-description"
      PaperProps={{
        sx: {
          overflow: 'hidden',
          borderRadius: 4,
          background:
            'linear-gradient(180deg, #fff5ea 0%, #fffaf4 55%, #fffdf9 100%)',
        },
      }}
    >
      <DialogTitle
        id="wedding-ad-dialog-title"
        sx={{
          textAlign: 'center',
          pt: 4,
          pb: 1,
          fontWeight: 700,
        }}
      >
        {'Faire-part officiel'}
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          pb: 2,
        }}
      >
        <Box
          sx={{
            mb: 3,
            px: { xs: 1, sm: 2 },
            py: { xs: 1.5, sm: 2.5 },
            borderRadius: 4,
            backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 0.28) 0%, rgba(255, 245, 232, 0.22) 100%), url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow:
              'inset 0 0 0 1px rgba(255, 255, 255, 0.4), 0 18px 40px rgba(85, 52, 24, 0.08)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                px: 2,
                py: 0.75,
                borderRadius: 999,
                bgcolor: 'rgba(35, 27, 20, 0.68)',
                color: '#f7e6c7',
                fontSize: { xs: '0.85rem', sm: '0.95rem' },
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                boxShadow: '0 10px 24px rgba(35, 27, 20, 0.18)',
              }}
            >
              {'Mariage : Wet Obscure : Expédition 33'}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(2, minmax(0, 1fr))',
                sm: 'repeat(3, minmax(0, 1fr))',
              },
              gap: { xs: 1.5, sm: 2.25 },
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            {weddingImages.map((image, index) => (
              <Box
                key={image.alt}
                sx={{
                  width: '100%',
                  maxWidth: {
                    xs: index === 2 ? 158 : 150,
                    sm: index === 0 || index === 4 ? 190 : 178,
                  },
                  p: 1,
                  borderRadius: 3,
                  bgcolor: 'white',
                  boxShadow: '0 18px 40px rgba(85, 52, 24, 0.18)',
                  transform: {
                    xs: 'none',
                    sm: `rotate(${image.rotation})`,
                  },
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: {
                      xs: 'none',
                      sm: 'rotate(0deg) translateY(-4px)',
                    },
                    boxShadow: '0 22px 44px rgba(85, 52, 24, 0.22)',
                  },
                }}
              >
                <Box
                  sx={{
                    height: {
                      xs: index === 2 ? 132 : 122,
                      sm: index === 0 || index === 4 ? 176 : 164,
                    },
                    borderRadius: 2.5,
                    overflow: 'hidden',
                    border: `3px solid ${image.accent}`,
                  }}
                >
                  <Box
                    component="img"
                    src={image.src}
                    alt={image.alt}
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'block',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
        <Box
          id="wedding-ad-dialog-description"
          sx={{
            textAlign: 'center',
            px: { xs: 1, sm: 3 },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 1.5,
              fontWeight: 700,
              color: '#8f4b2b',
            }}
          >
            {`Arnaud "Judas" + Léo "Meetic"`}
          </Typography>
          <Typography
            sx={{
              mb: 1,
              fontSize: '1.05rem',
              lineHeight: 1.7,
            }}
          >
            {
              'Vous êtes officiellement invités à leur mariage samedi à 12 h, sous le thème "Wet Obscure : Expédition 33". Venez voir Fleuh faire son meilleur Renoir'
            }
          </Typography>
          <Typography
            sx={{
              color: 'text.secondary',
              lineHeight: 1.7,
            }}
          >
            {
              'Merci de venir célébrer cet événement historique avec votre plus beau sourire, une tenue irréprochable (ou pas) et un enthousiasme parfaitement disproportionné.'
            }
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 0 }}>
        <Button onClick={onClose} autoFocus variant="contained">
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
